import { Outlet, ScrollRestoration } from 'react-router-dom'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { KeyboardDebugOverlay } from '@/components/keyboard-debug-overlay'
import { OfflineBanner } from '@/components/offline-banner'
import { env } from '@/lib/config/env'
import { useKeyboardInset } from '@/lib/ui/use-keyboard-inset'
import { useProximityLocation } from '@/features/notifications/hooks/use-proximity-location'
import { useNativePushLifecycle } from '@/features/notifications/hooks/use-native-push'
import { useWebPushSync } from '@/features/notifications/hooks/use-web-push-sync'
import { StartupGate } from '@/features/auth/startup/gates'
import { SplashScreen } from './splash/splash-screen'
import {
  hasSplashCompleted,
  markSplashCompleted,
} from './splash/splash-state'
import { RouteMetadata } from './route-metadata'

/**
 * The brand splash belongs to the first document load, not to the `/` route.
 * Mounting it at the layout level means a deep link (`/activity/:id`,
 * `/login`, a reset link) still gets the same branded start.
 */
export function RootLayout() {
  const { t } = useTranslation()
  const [splashDone, setSplashDone] = useState(hasSplashCompleted)
  useKeyboardInset()
  useProximityLocation()
  useWebPushSync()
  useNativePushLifecycle()

  return (
    <>
      {env.clientPlatform !== 'android' && env.clientPlatform !== 'ios' ? (
        <a className="skip-link" href="#main-content">
          {t('common.skipToContent')}
        </a>
      ) : null}
      <OfflineBanner />
      <RouteMetadata />
      <StartupGate>
        <Outlet />
      </StartupGate>
      <ScrollRestoration />
      <KeyboardDebugOverlay />
      {!splashDone ? (
        <SplashScreen
          onDone={() => {
            markSplashCompleted()
            setSplashDone(true)
          }}
        />
      ) : null}
    </>
  )
}
